<template>
  <div>
    <NavigationAppbar></NavigationAppbar>
    <v-main style="padding: 0 !important;">
        <router-view></router-view>
    </v-main>
    <v-footer app>
      <LayoutFooter></LayoutFooter>
    </v-footer>
  </div>
</template>

<script>
import LayoutFooter from '../../views/admin/layout/LayoutFooter'
import NavigationAppbar from '../../views/boarder/layout/NavigationAppbar'
export default {
  name: 'Layout',
  components: { NavigationAppbar, LayoutFooter }
}
</script>

<style scoped>
  .container-fluid{
    width: 100% !important;
    padding: 0;
    margin: 0;
  }
</style>
